/**
 * Construction des cellules d'un export WYSIWYG (Excel), en JS pur — sans
 * `xlsx` pour rester testable par la CI de l'API (api/scripts/testTimetrackingExport.ts).
 */

/**
 * Neutralise la CSV/Formula injection (F-S22-01) : une cellule string commençant
 * par `= + - @` (ou tab/CR) est interprétée comme une formule par Excel/
 * LibreOffice → exfiltration (HYPERLINK/WEBSERVICE) ou DDE. On préfixe une
 * apostrophe pour forcer l'interprétation texte. `notes` est saisi librement par
 * un USER, `taskName`/`affaireName` proviennent de Float → tous user-controlled.
 */
export function sanitizeCell(v) {
  if (typeof v === 'string' && /^[=+\-@\t\r]/.test(v)) return `'${v}`;
  return v;
}

/**
 * Tableau de tableaux (en-tête + lignes) prêt pour `XLSX.utils.aoa_to_sheet`.
 * Les nombres restent des nombres (cellules numériques dans Excel).
 *
 * @param {Array<Object>} rows
 * @param {Array<{key:string,label:string,format?:(v:any,row:Object)=>any}>} columns
 */
export function buildExportAoa(rows, columns) {
  const header = columns.map((c) => c.label);
  const body = (rows ?? []).map((row) =>
    columns.map((c) => {
      const raw = row[c.key];
      return sanitizeCell(c.format ? c.format(raw, row) : raw);
    }),
  );
  return [header, ...body];
}

/** Nom de fichier sûr (sans extension) : `[a-zA-Z0-9_-]` uniquement, 80 car. max. */
export function safeExportFilename(filename) {
  return String(filename ?? '').replace(/[^a-zA-Z0-9_-]+/g, '_').slice(0, 80) || 'export';
}
